// extracted by mini-css-extract-plugin
module.exports = {"singleSection":"singleSection_singleSection__TElnx"};